import React from 'react';

import { useSelectedDevice } from '../../services/DeviceService/DevicesHooks';
import { useGlobalStore } from '../../services/GlobalStoreService/GlobalStoreHooks';

import DataTable from '../DataTable2/DataTable.jsx';

import DeviceIcon from '../DeviceCommons/DeviceIcon/DeviceIcon';

import InnerSpinner from '../Loading/InnerSpinner';
import NoData from '../NoData/NoData';
import deviceTypeIdToText from '../../utils/deviceTypeIdToText';

import './alarm-list.scss';

export default function AlarmList(props) {
    // eslint-disable-next-line
    const [device, , changeSelection] = useSelectedDevice();

    const [mode, setMode] = useGlobalStore('mode');

    const alerts = props.alerts;

    function selectDevice(alarm) {
        if (mode !== 'EDIT') {
            changeSelection(alarm.device_Code ? alarm.device_Code : alarm.device_Id);
        }
        else {
            if(!device) {
                setMode("READ");
                changeSelection(alarm.device_Code ? alarm.device_Code : alarm.device_Id);
            }
        }        
    }

    if (props.alerts === 'LOADING') {
        return (
            <div className="alarm-list alarm-list-loading">
                <InnerSpinner />
            </div>
        );
    }

    if (props.alerts !== 'LOADING' && alerts.length === 0 && (props.totalCount === null || props.totalCount === 0)) {
        return (
            <div className="alarm-list ">
                <NoData message="There is no active alerts available for the devices of selected organization." />
            </div>
        );
    }

    if (alerts.length === 0 && props.totalCount !== 0) {
        return (
            <div className="alarm-list">
                <p>
                    Listing {alerts.length} / {props.totalCount} alerts.
                </p>
                <h2>No results found with current filters and search string.</h2>
            </div>
        );
    }

    function getAlarmSeverityLevel(severity) {
        if (severity > 0.99) return 'oos';
        if (severity >= 0.89) return 'urgent';
        if (severity >= 0.79) return 'critical';
        if (severity >= 0.59) return 'informative';
        return 'note';
    }

    // Currently not showing data for device name, status and type as fetching those will make the actual query A LOT slower. We need to make
    // a decision what is the priority of this information
    const columns = [
        {
            key: 'severity',
            header: 'Alarm Priority',
            content: sev => {
                const sevLevel = getAlarmSeverityLevel(sev);
                switch (sevLevel) {
                    case 'oos':
                        return <span className="alarm-severity oos">Out of service</span>;
                    case 'urgent':
                        return <span className="alarm-severity urgent">Urgent</span>;
                    case 'critical':
                        return <span className="alarm-severity critical">Critical</span>;
                    case 'informative':
                        return <span className="alarm-severity informative">Informative</span>;
                    default:
                    case 'note':
                        return <span className="alarm-severity note">Note</span>;
                }
            },
            width: '120px',
        },
        {
            key: 'triggerCounter',
            header: 'Count',
            className: 'large-cell-text',
            width: '100px',
        },
        {
            key: 'type',
            header: 'Type',
            width: '120px',
        },
        {
            key: 'device',
            content: deviceType => {
                return (
                    <React.Fragment>
                        {/*<DeviceIcon device={deviceType} />*/}
                        {deviceTypeIdToText(deviceType ? deviceType.type : null)}
                    </React.Fragment>
                );
            },
            sortFn: (a, b) => {
                return a.device.type.localeCompare(b.device.type);
            },
            className: 'flex-cell',
            header: 'Device Type',
            width: '130px',
        },
        {
            key: 'device_name',
            header: 'Device Name',
            className: '130px',
        },
        {
            key: 'description',
            header: 'Alert Description',
            className: 'large-width-cell',
        },
        {
            key: 'lastTimeSeen',
            header: 'Last seen',
            type: 'datetime',
            width: '130px',
        },
    ];

    return (
        <div className="alarm-list">
            <p>
                Listing {alerts.length} / {props.totalCount} alerts.
            </p>
            {alerts.length > 0 && <DataTable data={alerts} columns={columns} rowOnClick={selectDevice} />}
        </div>
    );
}
